<template>
  <div class="bg-dark2">
    <!-- Indiefy PRO -->
    <section>
      <!--  MOBILE -->
      <div class="px-2 pt-4 d-lg-none pb-3">
        <div class="text-white mb-5 d-lg-none text-center">
          <div class="text-45 mb-2">
            <span class="fw-extralight text-poppins">INDIEFY</span><span class="ml-3 bold-800 text-poppins">PRO</span>
          </div>
          <p class="mb-0 line-height mx-5 text-18 tablet-centered">{{ $t('indiefy_pro_subtitle_desktop') }}</p>
        </div>
        <div class="text-center mb-2">
          <button type="button" @click="redirectToCheckout()" class="btn btn-lg btn-gradient text-poppins tablet-centered">{{ $t('start_now') }}</button>
        </div>
        <div class="bg-black text-white fw-bold mt-4" style="border-radius: 3px;">
          <div class="p-2">
            <i class="fa fa-check mr-1"></i> {{ $t('advanced_ai_tools') }} *
          </div>
          <div class="p-2">
            <i class="fa fa-check mr-1"></i> {{ $t('pro_royalties_percentage') }} *
          </div>
          <div class="p-2">
            <i class="fa fa-check mr-1"></i> {{ $t('social_accounts_verification') }} *
          </div>
          <div class="p-2">
            <i class="fa fa-check mr-1"></i> {{ $t('spotify_promotion') }} & Playlists
          </div>
          <div class="p-2">
            <i class="fa fa-check mr-1"></i> {{ $t('copyright_protection') }} (Content ID)
          </div>
          <div class="p-2">
            <i class="fa fa-check mr-1"></i> {{ $t('royalty_splits') }}
          </div>
        </div>
        <!-- <div class="text-center">
          <a href="https://help.indiefy.net/hc/en-us/articles/360051158334-Why-should-I-have-a-PRO-subscription-" target="_blank" class="btn btn-link text-poppins my-3 text-white">{{ $t('more_info') }}</a>
        </div> -->
        <div class="marquee-container mt-3">
          <div class="marquee-title bg-dark">
            Latest PRO
          </div>
          <marquee class="card-round bg-dark p-2 text-white">
            <span v-for="item in proArtists" v-bind:key="`top_${item._id}`" class="mr-4">
              <a class="blue-text" target="_blank" :href="`https://indiefy.me/${item.key}`"><img class="mr-1" width="16" onerror="this.src = '/static/img/img-placeholder-dark.jpg'" :src="`/static/img/countries/${item.user.country || 'default'}.png`"> {{ item.name }}</a>
            </span>
          </marquee>
        </div>
        <!-- <div>
          <div class="d-flex flex-wrap align-content-end gif-container">
            <div class="media mt-4 w-75 mx-auto line-height tablet-centered">
              <img src="/static/img/branding/indiefy-logo-white.png" alt="logo" width="40%">
              <div class="media-body ml-2 mt--1">
                <p class="text-white text-small line-heigth">{{ $t('shawn_fanning_text') }}</p>
                <p class="text-white text-small">Shawn Fanning</p>
              </div>
            </div>
          </div>
        </div> -->
      </div>

      <!-- DESKTOP -->
      <div class="px-4 pt-4 d-none d-lg-block background-img-section-one pt-5 py-5" :class="{ 'vh-100': isDesktop()}">
        <div class="">
          <div class="text-white mb-5">
            <div class="text-100 mb-2 text-center">
              <span class="fw-extralight text-poppins">INDIEFY</span><span class="ml-3 bold-800 text-poppins">PRO</span>
            </div>
            <div class="text-center">
              <p class="line-height h4 mt--2 mx-auto text-22" :class="{'w-75': !isLargeScreen(), 'w-50':  isLargeScreen() }">{{ $t('indiefy_pro_subtitle_desktop') }}</p>
            </div>
          </div>
          <div class="text-center">
            <button type="button" @click="redirectToCheckout()" class="btn btn-gradient btn-lg text-poppins">{{ $t('start_now') }}</button>
          </div>
          <!-- <div class="mt-2 text-center">
            <a href="https://help.indiefy.net/hc/en-us/articles/360051158334-Why-should-I-have-a-PRO-subscription-" target="_blank" class="btn btn-link text-poppins text-white w-25">{{ $t('more_info') }}</a>
          </div> -->
          <div class="px-3">
            <div class="row bg-black text-center text-white fw-bold mt-4" style="font-size: 16px;">
              <div class="col-md-12 p-2">
                <i class="fa fa-check mr-1"></i> {{ $t('advanced_ai_tools') }}
              </div>
              <div class="col-md-6 p-2">
                <i class="fa fa-check mr-1"></i> {{ $t('pro_royalties_percentage') }} *
              </div>
              <div class="col-md-6 p-2">
                <i class="fa fa-check mr-1"></i> {{ $t('social_accounts_verification') }} *
              </div>
              <div class="col-md-6 p-2">
                <i class="fa fa-check mr-1"></i> {{ $t('spotify_promotion') }} & Playlists
              </div>
              <div class="col-md-6 p-2">
                <i class="fa fa-check mr-1"></i> {{ $t('copyright_protection') }} (Content ID)
              </div>
              <div class="col-md-6 p-2">
                <i class="fa fa-check mr-1"></i> {{ $t('royalty_splits') }}
              </div>
              <div class="col-md-6 p-2">
                <i class="fa fa-check mr-1"></i> {{ $t('premium_stores') }}
              </div>
            </div>
          </div>
          <div class="marquee-container mt-4">
            <div class="marquee-title bg-dark">
              Latest PRO
            </div>
            <marquee class="card-round bg-dark p-2 text-white">
              <span v-for="item in proArtists" v-bind:key="`top_${item._id}`" class="mr-4">
                <a class="blue-text" target="_blank" :href="`https://indiefy.me/${item.key}`"><img class="mr-1" width="16" onerror="this.src = '/static/img/img-placeholder-dark.jpg'" :src="`/static/img/countries/${item.user.country || defaultImage}.png`"> {{ item.name }}</a>
              </span>
            </marquee>
          </div>
        </div>
        <!-- <div class="d-flex h-25 pl-4 mt-4">
          <div class="media line-height w-25 align-self-end">
            <img src="/static/img/branding/indiefy-logo-white.png" alt="logo" height="20%" width="40%">
            <div class="media-body ml-2 mt--1">
              <span class="text-white text-14 line-heigth">{{ $t('shawn_fanning_text') }}</span>
              <p class="text-white text-small mt-2">Shawn Fanning</p>
            </div>
          </div>
        </div> -->
      </div>
    </section>
    <!-- SOCIAL APPS -->
    <section class="bg-white pt-5">
      <div class="ml-5" :class="{'mx-auto': isSmallScreen()}">
        <div class="row py-6">
          <div class="col-12 col-md-6 align-self-center" :class="{'text-center': isSmallScreen()}">
            <p class="text-30 strong mb-0 text-poppins">{{ $t('introducing') }}</p>
            <p class="text-uppercase text-60 social-stores bold-800 line-height text-poppins">{{ $t('social_stores') }}</p>
            <div class="mt-3 w-100 mb-5">
              <div class="d-flex justify-content-center align-items-center mx-auto">
                <div class="text-center">
                  <img src="static/img/tiktok-logo.png" alt="" class="social-apps-img">
                </div>
                <div class="mx-4 text-center">
                  <span class="social-apps-icons text-black">
                    <i class="fab fa-facebook-f"></i>
                </span>
                </div>
                <div class="text-center">
                  <span class="social-apps-icons text-black">
                    <i class="fab fa-instagram"></i>
                  </span>
                </div>
              </div>
            </div>
            <p class="w-75 line-height mt-4 text-18 d-lg-none" :class="{'mx-auto': isSmallScreen()}">{{ $t('social_stores_info') }}</p>
            <p class="w-75 line-height mt-4 text-22 d-none d-lg-block">{{ $t('social_stores_info') }}</p>
            <button type="button" @click="redirectToCheckout()" class="btn btn-gradient mb-5 mt-3 text-poppins">{{ $t('social_stores_button') }}</button>
          </div>
          <div class="col-12 col-md-6 align-self-center background-social-stores pt-5" :class="{'text-center': isSmallScreen()}">
            <div id="carouselExampleIndicators" ref="carousel" class="carousel slide carousel-fade" data-ride="carousel" data-pause="false" data-keyboard="false">
              <ol class="carousel-indicators d-none d-md-flex">
                <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="4"></li>
              </ol>
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img class="d-block" :class="{'w-50 mx-auto': isSmallScreen(), 'h-50 mx-auto': !isSmallScreen()}" src="static/img/landing/pro/social_stores_carousel/social_stores_1.png" alt="First slide">
                </div>
                <div class="carousel-item">
                  <img class="d-block" :class="{'w-50 mx-auto': isSmallScreen(), 'h-50 mx-auto': !isSmallScreen()}" src="static/img/landing/pro/social_stores_carousel/social_stores_2.png" alt="Second slide">
                </div>
                <div class="carousel-item">
                  <img class="d-block" :class="{'w-50 mx-auto': isSmallScreen(), 'h-50 mx-auto': !isSmallScreen()}" src="static/img/landing/pro/social_stores_carousel/social_stores_3.png" alt="third slide">
                </div>
                <div class="carousel-item">
                  <img class="d-block" :class="{'w-50 mx-auto': isSmallScreen(), 'h-50 mx-auto': !isSmallScreen()}" src="static/img/landing/pro/social_stores_carousel/social_stores_4.png" alt="Four slide">
                </div>
                <div class="carousel-item">
                  <img class="d-block" :class="{'w-50 mx-auto': isSmallScreen(), 'h-50 mx-auto': !isSmallScreen()}" src="static/img/landing/pro/social_stores_carousel/social_stores_5.png" alt="Five slide">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Always in Control -->
    <section class="bg-white pb-5">
      <!-- MOBILE -->
      <div class="d-lg-none pb-5">
        <div class="text-center">
          <p class="text-30 strong mb-0 text-poppins text-center pt-4">{{ $t('always') }}</p>
          <p class="text-uppercase text-50 social-stores bold-800 line-height text-poppins text-stroke">{{ $t('in_control') }}</p>
          <p class="line-height mb-1 text-18 w-75 mx-auto">{{ $t('in_control_text1') }}</p>
          <p class="line-height text-18 w-75 mx-auto">{{ $t('in_control_text2') }}</p>
          <button type="button" @click="redirectToCheckout()" class="btn btn-gradient text-poppins my-3">{{ $t('get_your_access') }}</button>
        </div>
        <div class="always-in-control-background-right mt-4 text-center mb-5">
          <img src="static/img/landing/pro/nitro-goyri.jpg" alt="nitro-goyri.jpg" class="br-5 box-shadow">
        </div>
      </div>
      <!-- DESKTOP -->
      <div class="row d-none d-lg-flex py-5">
        <div class="col-md-3 align-self-center always-in-control-background-left my-5">
          <img src="static/img/landing/pro/carlos-sarabia.jpg" alt="carlos-sarabia" class="br-5 ml-5 box-shadow">
        </div>
        <div class="col-md-6 align-self-center text-center">
          <p class="text-30 strong mb-0 text-poppins text-center">{{ $t('always') }}</p>
          <p class="text-uppercase text-60 social-stores bold-800 line-height text-poppins text-stroke">{{ $t('in_control') }}</p>
          <p class="line-height text-22 mb-0 ">{{ $t('in_control_text1') }}</p>
          <p class="line-height text-22">{{ $t('in_control_text2') }}</p>
          <button type="button" @click="redirectToCheckout()" class="btn btn-gradient text-poppins mt-4">{{ $t('get_your_access') }}</button>
        </div>
        <div class="col-md-3 align-self-center always-in-control-background-right my-5 text-right">
          <img src="static/img/landing/pro/nitro-goyri.jpg" alt="nitro-goyri.jpg" class="br-5 mr-5 box-shadow">
        </div>
      </div>
    </section>
    <!-- DELIVERY SPEED -->
    <section class="bg-white">
      <!-- MOBILE -->
      <div class="d-lg-none text-center">
        <p class="text-30 strong text-poppins mb-0 line-height">{{ $t('top_feature') }}</p>
        <p class="text-stroke text-50 text-uppercase bold-800 text-poppins line-height">{{ $t('delivery') }} <span class="font-italic">{{ $t('speed') }}</span></p>
        <p class="text-18 w-75 mx-auto line-height">{{ $t('delivery_speed_text') }}</p>
        <button type="button" @click="redirectToCheckout()" class="btn btn-gradient text-poppins my-3">{{ $t('deliver_now') }}</button>
        <div class="row mt-5">
          <div class="col-md-5">
            <img src="static/img/landing/pro/mariachi.png" alt="mariachi" class="br-5 box-shadow" v-if="lang === 'es'">
            <img src="static/img/landing/pro/artist.png" alt="artist" class="br-5 box-shadow" v-else>
          </div>
          <div class="col-md-7 mt-3">
            <div class="bg-white-smoke-light p-3 br-5 mx-5 text-14">
              <div v-html="$t('delivery_speed_testimony')" class="line-height"></div>
            </div>
          </div>
        </div>
        <div class="battery-container pt-5 pb-2">
          <div class="battery animated fadeIn">
            <div class="top"></div>
            <div class="charge1"></div>
            <div class="charge2"></div>
            <div class="charge3"></div>
            <div class="charge4"></div>
            <div class="charge5"></div>
            <div class="bolt">
              <span class="h1"><i class="fas fa-bolt"></i></span>
            </div>
          </div>
        </div>
        <div class="text-center pb-5">
          <img src="static/img/landing/pro/stores.png" alt="apps" class="w-75 image-stores">
        </div>
      </div>
      <!-- DESKTOP -->
      <div class="d-none d-lg-flex ml-5 pt-5">
        <div class="row w-100">
          <div class="col-md-6 col-lg-6">
            <p class="text-30 strong text-poppins mb-0 line-height">{{ $t('top_feature') }}</p>
            <p class="text-stroke text-60 text-uppercase bold-800 text-poppins line-height">{{ $t('delivery') }} <span class="font-italic">{{ $t('speed') }}</span></p>
            <p class="text-22 w-75 line-height">{{ $t('delivery_speed_text') }}</p>
            <button type="button" @click="redirectToCheckout()" class="btn btn-gradient text-poppins my-3">{{ $t('deliver_now') }}</button>
            <div class="row mt-5 mb-5">
              <div class="col-md-5 mb-5">
                <img src="static/img/landing/pro/mariachi.png" alt="mariachi" class="br-5 box-shadow" v-if="lang === 'es'">
                <img src="static/img/landing/pro/artist.png" alt="artist" class="br-5 box-shadow" v-else>
              </div>
              <div class="col-md-7">
                <div class="bg-white-smoke-light p-3 br-5 text-14 bold-800">
                  <div v-html="$t('delivery_speed_testimony')"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-6 text-center">
            <div class="battery-container pt-5 pb-2">
              <div class="battery animated fadeIn">
                <div class="top"></div>
                <div class="charge1"></div>
                <div class="charge2"></div>
                <div class="charge3"></div>
                <div class="charge4"></div>
                <div class="charge5"></div>
                <div class="bolt">
                  <span class="h1"><i class="fas fa-bolt"></i></span>
                </div>
              </div>
            </div>
            <div class="mb-5">
              <img src="static/img/landing/pro/stores.png" alt="apps" class="w-100 px-5 image-stores">
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- FASTER PAYMENTS -->
    <section class="bg-white pt-5">
      <!-- MOBILE -->
      <div class="d-lg-none py-5 text-center">
        <p class="text-50 text-popins text-uppercase bold-800 line-height-0-9 mb-0">{{ $t('faster_payments') }}</p>
        <p class="text-18 line-height my-5 w-75 mx-auto">{{ $t('faster_payments_text') }}</p>
        <button type="button" @click="redirectToCheckout()" class="btn btn-gradient text-poppins mb-5">{{ $t('deliver_now') }}</button>
        <div class="align-self-center">
          <img src="static/img/landing/pro/money_guy.gif" alt="gif" class="money-guy box-shadow br-5">
        </div>
      </div>
      <!-- DESKTOP -->
      <div class="d-none d-lg-flex py-5">
        <div class="row mb-5 w-100 mx-5">
          <div class="col-md-3 text-left pl-0">
            <img src="static/img/landing/pro/money.gif" alt="gif" class="money box-shadow br-5">
          </div>
          <div class="col-md-6 text-center">
            <p class="text-60 text-popins text-uppercase faster-payments bold-800 line-height-0-9 mb-0">{{ $t('faster_payments') }}</p>
            <p class="text-60 text-popins text-uppercase bold-800 line-height-0-9 mb-0">{{ $t('faster_payments') }}</p>
            <p class="text-60 text-popins text-uppercase faster-payments bold-800 line-height-0-9 mb-0">{{ $t('faster_payments') }}</p>
            <p class="text-22 line-height my-5">{{ $t('faster_payments_text') }}</p>
            <button type="button" @click="redirectToCheckout()" class="btn btn-gradient text-poppins mb-5">{{ $t('deliver_now') }}</button>
          </div>
          <div class="col-md-3 text-right pr-0">
            <img src="static/img/landing/pro/money_guy.gif" alt="gif" class="money-guy box-shadow br-5">
          </div>
        </div>
      </div>
    </section>
    <!-- INDIEFY ME -->
    <section>
      <!-- MOBILE -->
      <div class="row text-white p-0 d-block d-md-none background-img-indiefy-me pb-5">
        <div class="col-md-12 text-center p-5">
          <p class="text-45 text-shadow line-height text-poppins fw-extralight">INDIEFY.ME</p>
          <p class="w-75 mx-auto line-height mb-5 text-18">{{ $t('landing_pro_indiefy_me_info') }}</p>
          <div class="mt-4 strong">
            <div class="h2">
              <i class="far fa-check-circle"></i>
            </div>
            <p>{{ $t('embed_spotify_player') }}</p>
            <div class="h2">
              <i class="far fa-check-circle"></i>
            </div>
            <p>{{ $t('add_your_bio') }}</p>
            <div class="h2">
              <i class="far fa-check-circle"></i>
            </div>
            <p>{{ $t('add_your_videos_photos') }}</p>
            <div class="h2">
              <i class="far fa-check-circle"></i>
            </div>
            <p>{{ $t('customizable') }}</p>
            <button type="button" @click="redirectToCheckout()" class="btn btn-gradient text-poppins text-uppercase text-white mt-4">{{ $t('build_indiefy_me') }}</button>
          </div>
        </div>
      </div>
      <!-- DESKTOP -->
      <div class="d-none d-md-block background-img-indiefy-me py-5" :class="{ 'vh-100': isDesktop()}">
        <div class="row text-white mx-5">
          <div class="col-md-6 mb-5 px-0">
            <p class="text-70 text-shadow line-height text-poppins fw-extralight">INDIEFY.ME</p>
            <p class="line-height w-75 text-22 my-5 text-left">{{ $t('landing_pro_indiefy_me_info') }}</p>
            <div class="mt-4 strong">
              <div class="my-2">
                <span class="h4">
                  <i class="far fa-check-circle"></i>
                </span>
                <span class="ml-2">{{ $t('embed_spotify_player') }}</span>
              </div>
              <div class="my-2">
                <span class="h4">
                  <i class="far fa-check-circle"></i>
                </span>
                <span class="ml-2">{{ $t('add_your_bio') }}</span>
              </div>
              <div class="my-2">
                <span class="h4">
                  <i class="far fa-check-circle"></i>
                </span>
                <span class="ml-2">{{ $t('add_your_videos_photos') }}</span>
              </div>
              <div class="my-2">
                <span class="h4">
                  <i class="far fa-check-circle"></i>
                </span>
                <span class="ml-2">{{ $t('customizable') }}</span>
              </div>
              <div class="my-2">
                <button type="button" @click="redirectToCheckout()" class="btn btn-gradient text-poppins text-uppercase text-white mt-4">{{ $t('build_indiefy_me') }}</button>
              </div>
            </div>
          </div>
          <div class="col-md-6 text-center mb-5">
            <a href="https://indiefy.me/head-twister" target="_blank">
              <img src="/static/img/landing/pro/indiefy_me.jpg" alt="indiefy-me" class="w-75 mt-5">
            </a>
            </div>
         </div>
       </div>
    </section>
    <!-- PRICING -->
    <section>
      <!-- MOBILE -->
      <div class="d-lg-none py-5">
        <div class="row text-white">
          <div class="col-12 col-sm-12 col-md-12 text-center exclusive-pricing-background">
            <p class="text-22 pt-4 strong text-poppins">{{ $t('exclusive_price') }}</p>
            <p><span class="text-50">$</span>
              <span class="text-50">{{ proCost }}/</span>
              <span class="text-22">{{ $t('month') }}</span>
              <br>{{ $t('billed_yearly') }}
            </p>
            <p class="text-18 line-height w-75 mx-auto">{{ $t('exclusive_price_info') }}</p>
            <button type="button" @click="redirectToCheckout()" class="btn btn-gradient text-poppins mt-4">{{ $t('get_your_access') }}</button>
          </div>
          <div class="col-12 col-sm-12 col-md-12 mt-4">
            <div>
              <div class="btn-gradient pt-3 mx-3">
                <div class="text-white strong bg-purple">
                  <p class="py-2 pl-4 text-poppins text-18">{{ $t('additional_benefits') }}</p>
                </div>
                <ul class="list-unstyled pt-2 pb-4 pl-5">
                  <li class="position-relative">
                    <span class="text-success text-8"><i class="fas fa-circle position-absolute aditional-benefits-icon-mobile"></i></span>{{ $t('immediate_verification') }}
                  </li>
                  <li class="position-relative">
                    <span class="text-success text-8"><i class="fas fa-circle position-absolute aditional-benefits-icon-mobile"></i></span>{{ $t('create_unlimited_releases') }}
                  </li>
                  <li class="position-relative">
                    <span class="text-success text-8"><i class="fas fa-circle position-absolute aditional-benefits-icon-mobile"></i></span>{{ $t('unlock_store_selector') }}
                  </li>
                  <li class="position-relative">
                    <span class="text-success text-8"><i class="fas fa-circle position-absolute aditional-benefits-icon-mobile"></i></span>{{ $t('metadata_changes_included') }}
                  </li>
                  <li class="position-relative">
                    <span class="text-success text-8"><i class="fas fa-circle position-absolute aditional-benefits-icon-mobile"></i></span>{{ $t('add_your_own_label_name') }}
                  </li>
                  <li class="position-relative">
                    <span class="text-success text-8"><i class="fas fa-circle position-absolute aditional-benefits-icon-mobile"></i></span>{{ $t('special_discounts') }}
                  </li>
                  <li class="position-relative">
                    <span class="text-success text-8"><i class="fas fa-circle position-absolute aditional-benefits-icon-mobile"></i></span>{{ $t('pro_referred') }}
                  </li>
                </ul>
              </div>
              <div class="ml-3 vip-customer-container-mobile">
                <div class="mb-5 mt-4 position-absolute">
                  <button type="button" class="btn text-white bg-primary ml-4 py-3 px-4">{{ $t('vip_customer_service') }} <img src="static/img/horns.png" alt="emoji" class="avatar-xs ml-2"></button>
                  <img src="static/img/landing/pro/nohemi.jpg" alt="emoji" class="avatar-xl rounded-circle position-absolute">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- DESKTOP -->
      <div class="d-none d-lg-block exclusive-pricing-background my-5" :class="{ 'vh-100': isDesktop()}">
        <div class="row text-white mx-5 py-5">
          <div class="col-md-5 pl-0 mb-5">
            <p class="text-30 strong text-poppins">{{ $t('exclusive_price') }}</p>
            <div>
              <p class="mb-0 line-height fw-medium-bold text-poppins"><span class="text-60">$</span>
                <span class="text-80">{{ proCost }}/</span>
                <span class="text-60">{{ $t('month') }}</span>
                <br>{{ $t('billed_yearly') }}
              </p>
            </div>
            <p class="text-22 line-height mt-4">{{ $t('exclusive_price_info') }}</p>
            <button type="button" @click="redirectToCheckout()" class="btn btn-gradient text-poppins mt-5">{{ $t('get_your_access') }}</button>
          </div>
          <div class="col-md-4 mt-4">
            <div class="d-flex justify-content-center mt-5">
              <div>
                <div class="btn-gradient pt-3">
                  <div class="text-white strong bg-purple">
                    <p class="py-2 pl-4 text-poppins text-22">{{ $t('additional_benefits') }}</p>
                  </div>
                  <div class="pt-2 pb-4 pl-5 px-5">
                    <ul class="list-unstyled text-18">
                      <li class="position-relative">
                        <span class="text-success text-8"><i class="fas fa-circle position-absolute aditional-benefits-icon-desktop"></i></span>{{ $t('immediate_verification') }}
                      </li>
                      <li class="position-relative">
                        <span class="text-success text-8"><i class="fas fa-circle position-absolute aditional-benefits-icon-desktop"></i></span>{{ $t('minimum_payment_pro') }}
                      </li>
                      <li class="position-relative">
                        <span class="text-success text-8"><i class="fas fa-circle position-absolute aditional-benefits-icon-desktop"></i></span>{{ $t('more_royalties_through_premium_stores') }}
                      </li>
                      <li class="position-relative">
                        <span class="text-success text-8"><i class="fas fa-circle position-absolute aditional-benefits-icon-desktop"></i></span> TikTok, Instagram, Apple, {{ $t('and_more_ads') }}
                      </li>
                      <li class="position-relative">
                        <span class="text-success text-8"><i class="fas fa-circle position-absolute aditional-benefits-icon-desktop"></i></span>{{ $t('copyright_protection') }} ({{ $t('content_id') }})
                      </li>
                      <li class="position-relative">
                        <span class="text-success text-8"><i class="fas fa-circle position-absolute aditional-benefits-icon-desktop"></i></span>{{ $t('faster_payments') }}
                      </li>
                      <li class="position-relative">
                        <span class="text-success text-8"><i class="fas fa-circle position-absolute aditional-benefits-icon-desktop"></i></span>{{ $t('faster_release_dates') }}
                      </li>
                      <li class="position-relative">
                        <span class="text-success text-8"><i class="fas fa-circle position-absolute aditional-benefits-icon-desktop"></i></span>{{ $t('pro_artists_or_bands') }}
                      </li>
                      <li class="position-relative">
                        <span class="text-success text-8"><i class="fas fa-circle position-absolute aditional-benefits-icon-desktop"></i></span>{{ $t('pro_releases_month') }}
                      </li>
                      <li class="position-relative">
                        <span class="text-success text-8"><i class="fas fa-circle position-absolute aditional-benefits-icon-desktop"></i></span>{{ $t('custom_record_label') }}
                      </li>
                      <li class="position-relative">
                        <span class="text-success text-8"><i class="fas fa-circle position-absolute aditional-benefits-icon-desktop"></i></span>{{ $t('dedicated_support') }}
                      </li>
                      <li class="position-relative">
                        <span class="text-success text-8"><i class="fas fa-circle position-absolute aditional-benefits-icon-desktop"></i></span>{{ $t('unlock_all_features') }}
                      </li>
                      <li class="position-relative">
                        <span class="text-success text-8"><i class="fas fa-circle position-absolute aditional-benefits-icon-desktop"></i></span>{{ $t('presave_campaigns') }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="position-relative vip-customer-container">
                  <button type="button" class="btn btn-lg text-white bg-primary p-4">{{ $t('vip_customer_service') }} <img src="static/img/horns.png" alt="emoji" class="avatar-xs ml-2"></button>
                  <img src="static/img/landing/pro/nohemi.jpg" alt="emoji" class="avatar-xl rounded-circle position-absolute">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Public from '../services/public'
import User from '../services/user'
import _ from 'underscore'

export default {
  name: 'IndiefyPro',
  data: function () {
    return {
      locationSettings: {},
      stripe: null,
      user: {},
      defaultImage: '/static/img/img-placeholder.jpg',
      proArtists: [],
      proCost: 4.16,
      preSaveFAQ: 'https://help.indiefy.net/',
      lang: 'en'
    }
  },
  methods: {
    isSmallScreen: () => {
      return window.innerWidth < 768
    },
    isLargeScreen: () => {
      return window.innerWidth >= 1400
    },
    isDesktop: () => {
      return window.innerWidth >= 1025
    },
    checkout: function () {
      let plan = 'price_1LFOeXK9qKRAJ5zqfGt7fcx8' // Year

      if (this.user.role === 'admin') {
        plan = 'price_1GyOU6K9qKRAJ5zqOe9Mz64r'
      }

      this.stripe.redirectToCheckout({
        lineItems: [{ price: plan, quantity: 1 }],
        mode: 'subscription',
        customerEmail: this.user.email,
        successUrl: 'https://indiefy.net/v1/api/user/upgrading?session_id={CHECKOUT_SESSION_ID}',
        cancelUrl: 'https://indiefy.net/upgrade?cancelled=1'
      }).then(function (result) {
        if (result.error) {
          alert(result.error.message)
        }
      })
    },
    redirectToCheckout: function () {
      let subscriptionData = {
        from: this.$route.query.from || ''
      }

      if (window.localStorage) {
        subscriptionData.utm_campaign = localStorage.getItem('utm_campaign') || this.$route.query.utm_campaign || ''
        subscriptionData.utm_source = localStorage.getItem('utm_source') || this.$route.query.utm_source || ''
        subscriptionData.utm_medium = localStorage.getItem('utm_medium') || this.$route.query.utm_medium || ''
      }

      window.smartlook && window.smartlook('track', 'Checkout', { type: 'Subscriptions' })
      window.gtag && window.gtag('event', 'conversion', {'send_to': 'AW-323371496/1fPACNGmjZ0YEOiDmZoB'})

      User.setSubscriptionTrackingData(subscriptionData)
      this.$router.push('/upgrade?from=landing-pro')
    }
  },
  created: function () {
    this.user = this.$user
    window.document.title = 'Indiefy PRO | ' + this.$t('indiefy_pro_title')
    window.$('meta[property="og:title"]').attr('content', this.$t('indiefy_pro_title'))
    window.$('meta[name="description"]').attr('content', this.$t('indiefy_pro_description'))
    window.$('meta[property="og:description"]').attr('content', this.$t('indiefy_pro_description'))

    if (this.$i18n && this.$i18n.locale === 'es') {
      this.lang = 'es'
      this.preSaveFAQ = 'https://help.indiefy.net/'
    }

    Public.getPotentialArtists().then(response => {
      this.proArtists = _.shuffle(response.data)

      setTimeout(() => {
        window.prerenderReady = true
      }, 50)
    })

    Public.getLocationSettings().then(responseSettings => {
      this.locationSettings = responseSettings.data
    })
  },
  mounted: function () {
    let stripeKey = 'pk_live_Fy0LR9SOyRoSrq4Byoj3mQtS00GjNUCMRm'
    this.stripe = window.Stripe(stripeKey)

    setTimeout(() => {
      window.$(this.$refs.carousel).carousel({
        interval: 2000
      })
    }, 100)
  }
}
</script>
<style lang="scss" scoped>
  .hands {
    width: 100%;
  }

  .text-45 {
    font-size: 45px;
  }

  .text-70 {
    font-size: 70px;
    margin-bottom: 0px;
  }

  .text-shadow {
    text-shadow: 2px 2px 3px #000000;
  }

  .line-height {
    line-height: 1.5;
  }

  .background-img-section-one {
    background-image: url('/static/img/landing/pro/pro_background.jpg');
    background-size: cover;
  }
  .background-pro-guitar {
    background-image: url('/static/img/landing/pro/pro_background_guitar.jpg');
    background-size: cover;
  }

  .background-img-indiefy-me {
    background-image: url('/static/img/landing/pro/background_indiefy_me.jpg');
    background-size: cover;
    background-position: left;
  }

  .exclusive-pricing-background {
    background-image: url('/static/img/landing/pro/exclusive-pricing-background.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  .always-in-control-background-left {
    background-image: url('/static/img/landing/pro/background_vectors.png');
    background-size: cover;
    background-position: left;
  }

  .always-in-control-background-right {
    background-image: url('/static/img/landing/pro/background_vectors2.png');
    background-size: cover;
    background-position: right;
  }

  .aditional-benefits-icon-mobile {
    top: 6px;
    left: -25px;
  }

  .aditional-benefits-icon {
    top: 6px;
    left: 30px;
  }

  .aditional-benefits-icon-desktop {
    top: 6px;
    left: -24px;
  }

  .vip-customer-container {
    bottom: 40px;
    left: 340px;

    button {
      border-radius: 40px 40px 0px 40px;
    }

    img {
      top: 35px;
    }
  }

  .vip-customer-container-mobile {
    height: 150px;
    button {
      border-radius: 40px 40px 0px 40px;
    }

    img {
      bottom: -35px;
    }
  }

  .gif-container {
    height: 200px;
  }

  .faster-payments,
  .social-stores {
    -webkit-text-stroke: 1.8px black;  color: transparent;
  }

  .carousel-control-prev {
    left: 35%;
  }

  .carousel-control-next {
    right:35%;
  }

  .social-apps-icons {
    font-size: 2rem;
  }

  .social-apps-img {
    height: 2rem;
    width: 2rem;
  }

  .background-social-stores {
    background-image: url('/static/img/landing/pro/vectors-background.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  .bg-social-apps {
    background-color: #F1EEEE;
  }

  .money-guy {
    filter: hue-rotate(200deg);
  }

  .money {
    filter: hue-rotate(-300deg);
  }

  .image-stores {
    max-width: 500px;
  }

  @media (min-width: 576px) {
    .tablet-centered {
      width: 50% !important;
      margin-left: auto !important;
      margin-right: auto !important;
    }
  }

  @media (max-width: 1399px) {
    .background-img-section-one {
      background-position: bottom;
    }
  }

  @media (min-width: 1400px) {
    .background-img-section-one {
      background-position: left;
    }
  }

  .marquee-container {
    position: relative;

    a {
      color: #c8b3ff;
    }
  }

  .marquee-container marquee {
    padding-left: 100px;
  }

  .marquee-container .marquee-title {
    padding: 8px 9px;
    color: white;
    font-weight: bold;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 30%;
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/components/IndiefyPro.vue